import { generatePath, Navigate, useParams } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { ProShipment } from '@packlink/packlink-sdk';
import { APP_ROUTE } from '@pages/router/routes';
import { getIsCustomsRequiredInCheckout } from '@store/selectors/checkout';

export function CheckoutIndex() {
    const params = useParams();
    const queryClient = useQueryClient();
    const shipment = queryClient.getQueryData<ProShipment>(['checkout', 'shipment', params.id]);
    const isCustomsRequiredInCheckout = useSelector(getIsCustomsRequiredInCheckout);

    if (!params.id || !shipment) {
        return <Navigate to={generatePath(APP_ROUTE.CHECKOUT.STEP_INFO)} replace />;
    } else {
        const shipmentStateMap = getShipmentStateMap(isCustomsRequiredInCheckout, params.id);

        return (
            <Navigate
                to={
                    shipmentStateMap[shipment.step] ||
                    generatePath(APP_ROUTE.CHECKOUT.STEP_INFO, { id: params.id ?? null })
                }
                replace
            />
        );
    }
}

const getShipmentStateMap = (areCustomsRequired: boolean, id: string) => ({
    SEARCH_INFO: generatePath(APP_ROUTE.CHECKOUT.STEP_INFO, { id }),
    SERVICE_SELECTION: generatePath(APP_ROUTE.CHECKOUT.STEP_SERVICE, { id }),
    SHIPPING_DETAILS: generatePath(APP_ROUTE.CHECKOUT.STEP_ADDRESS, { id }),
    CUSTOMS: generatePath(APP_ROUTE.CHECKOUT.STEP_CUSTOMS, { id }),
    // RET-223 backend is still sending BILLING_INFO as step for the shipment
    // Backend is also sending BILLING_INFO as step for customs
    // this step should be removed when the info is correctly set
    BILLING_INFO: areCustomsRequired
        ? generatePath(APP_ROUTE.CHECKOUT.STEP_CUSTOMS, { id })
        : generatePath(APP_ROUTE.CHECKOUT.STEP_PAYMENT, { id }),
    PAYMENT: generatePath(APP_ROUTE.CHECKOUT.STEP_PAYMENT, { id }),
    PURCHASED: generatePath(APP_ROUTE.SHIPMENTS.DETAILS, { id }),
});
